// @flow

import React, { Component } from 'react';
import type { PieceData, PlacePuzzlePiece } from './types';

type Props = {
  activePiece: PieceData,
  placePuzzlePiece: PlacePuzzlePiece,
  helpAudio: string,
  fieldWidth: number,
};

type State = {
  playing: boolean,
  audio: any,
};

class HelpButton extends Component<Props, State> {
  constructor(props: Props): void {
    super(props);
    this.state = {
      playing: false,
      audio: new Audio(props.helpAudio),
    };
  }

  playAudio(): void {
    const { playing, audio } = this.state;

    if (playing) return;

    this.setState({
      playing: true,
    });

    audio.play().then(() => {
      this.setState({
        playing: false,
      });
    });
  }

  render(): ?React$Element<any> {
    const { activePiece, placePuzzlePiece, assetPath } = this.props;
    const pieceNumber = activePiece.number;

    const background = {
      backgroundImage: `url('${assetPath}assets/games/puzzle_game/helping_hand.png')`,
    };

    if (!activePiece) return null;

    return (
      <div
        className="puzzle__help-button h-12 w-12"
        style={{
          ...background,
        }}
        onClick={() => placePuzzlePiece(pieceNumber, pieceNumber, true)}
        onMouseEnter={() => this.playAudio()}
      />
    );
  }
}

export default HelpButton;
